export const formatNumberForDisplay = (num) =>
    Number.parseFloat(num).toPrecision(4);

export const getFirstNodeWithCheckPassing = (
    details,
    checkIfTargetFound,
    parentDetail,
) => {
    if (!details || !details.length) {
        return null;
    }

    const foundNode = details.reduce((prev, detail) => {
        if (prev) {
            return prev;
        }

        if (checkIfTargetFound(detail, parentDetail)) {
            return detail;
        }

        return getFirstNodeWithCheckPassing(
            detail.details,
            checkIfTargetFound,
            detail,
        );
    }, undefined);

    return foundNode;
};

export const getValueOfFirstNodeWithCheckPassing = (
    details,
    checkIfTargetFound,
    parentDetail,
) => {
    const foundNode = getFirstNodeWithCheckPassing(
        details,
        checkIfTargetFound,
        parentDetail,
    );

    if (foundNode) {
        return foundNode.value;
    }
};
